const urlReducer = (state = process.env.REACT_APP_BASE_URL, action) => {
    switch(action.type) {
        default:
            return state;
    }
}

export default urlReducer;
